var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Modal from "../../UI/Modal/Modal";
import { ModalCloseButton } from "../../UI/StandardButtons/StandardButtons";
import useService from "../../Hooks/useService";
import CourseBasedSuccesScoringService from "../../../Services/CourseBasedSuccessScoring.service";
import Loading from "../../UI/Loading/Loading";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import SuccessScoringTable from "../SuccessScoring/SuccessScoringTable";
const CourseBasedSuccessScoringModal = (_a) => {
    var { transcriptCourseId, affiliationId, studentName, courseSection } = _a, modalProps = __rest(_a, ["transcriptCourseId", "affiliationId", "studentName", "courseSection"]);
    const [reasons, loadReasons] = useService(CourseBasedSuccesScoringService.getScoreReasons);
    React.useEffect(() => {
        if (modalProps.isOpen) {
            loadReasons(transcriptCourseId, affiliationId);
        }
    }, [affiliationId, loadReasons, modalProps.isOpen, transcriptCourseId]);
    return (_jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx("div", { className: "modal-header", children: _jsx("h5", { className: "modal-title", children: "Course Completion Success Measures" }) }), _jsxs("div", { className: "modal-body", children: [_jsxs("h4", { className: "mb-3", children: [studentName, " ", courseSection &&
                                `in ${courseSection.code} ${courseSection.section} ${courseSection.name}`] }), reasons.isLoading && _jsx(Loading, { size: "3x", isCentered: true, className: "mt-3" }), reasons.hasError && (_jsx(AlertError, { message: "There was an error loading the success reasons for this student", detail: reasons.errorMessage })), reasons.data && _jsx(SuccessScoringTable, { scoring: reasons.data })] }), _jsx("div", { className: "modal-footer", children: _jsx(ModalCloseButton, { onClick: modalProps.onModalClosed }) })] })));
};
export default CourseBasedSuccessScoringModal;
